import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';

import ImageFluid from '../../legacy/components/base/ImageFluid';
import RawHtml from '../../legacy/components/base/RawHtml';
import { VerticalDivider } from './vertical-divider';
import { HorizontalDivider } from './horizontal-divider';

// ********************************************************************************
// Hero component featured in templates. This is based off the
// legacy Hero component in the old site.
// SEE: src/legacy/components/Hero/index.js
type Props = {
  title: string;
  description: string;

  textCall?: string;
  urlCall?: string;
  image: {
    small: string;
    medium: string;
    large: string;
  };
  // FIXME: This is a placeholder for now. This will be updated
  fluid: any;
};

export const Hero = (props: Props) => {
  // == Render ====================================================================
  return (
    <Box
      component="section"
      display="flex"
      alignItems="center"
      height={{ xs: 'auto', md: '344px' }}
      bgcolor="#3F2B56"
      flexWrap="wrap"
      sx={{
        backgroundImage: `url(/images/Hero/deco.svg)`,
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
      }}
      overflow="hidden"
    >
      <Box display="flex" justifyContent="flex-end" width={{ xs: '100%', md: '50%' }} p={4} pl="10%">
        <Stack spacing={3} maxWidth="800px">
          <Typography variant="h1" color="white" fontFamily="Gotham-Bold" fontSize="32px">
            <RawHtml content={props.title} />
          </Typography>
          <Typography
            variant="subtitle1"
            color="white"
            fontSize={{
              xs: '16px',
              lg: '24px',
            }}
            lineHeight="28px"
            fontFamily="Gotham-Light"
          >
            {props.description}
          </Typography>
          {props.urlCall && (
            <Button
              href={props.urlCall}
              variant="contained"
              color="primary"
              size="large"
              sx={{ width: { xs: '100%', sm: '200px' } }}
            >
              {props.textCall}
            </Button>
          )}
        </Stack>
      </Box>

      <Box width={{ xs: '100%', md: '50%' }} position="relative" height="100%">
        <VerticalDivider />
        <HorizontalDivider />
        <Box
          component="figure"
          sx={{
            clipPath: {
              xs: 'polygon(0 100px, 100% 0, 100% 100%, 0 100%)',
              md: 'polygon(160px 0%, 100% 0%, 100% 100%, 0% 100%)',
            },
          }}
          height="100%"
          pt={{ xs: '95px', md: 0 }}
          margin={0}
        >
          {props.fluid && <ImageFluid fluid={props.fluid} />}
        </Box>
      </Box>
    </Box>
  );
};
